export default (data, options = { maximumFractionDigits: 3, toLocaleString: true }) => {
  if (data === null) return null;
  if (data === undefined) return undefined;
  // console.log(data.toLocaleString(undefined, options).replace(/[0-9]/g, (w) => digits[+w]));

  const digits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  if (options.toLocaleString) return Number(data).toLocaleString(undefined, options).replace(/[0-9]/g, (w) => digits[+w]);
  return data.toString().replace(/[0-9]/g, (w) => digits[+w]);
};
